import type { ChartData } from './types'

const variables = {
  purple500: '#CAB3FA',
  blue700: '#77C4BB',
  grey100: '#F9F9F9',
  grey300: '#E5E5E5',
  grey500: '#555555',
  black: '#111111',
  white: '#ffffff',
  fontFamily: 'BodyFont, sans-serif',
}

// @doc https://echarts.apache.org/en/option.html
export function buildChartOptions(chartData: ChartData) {
  return {
    baseOption: {
      series: [
        {
          type: 'radar',
          symbol: 'none',
          data: chartData.data,
        },
      ],
      legend: {
        top: 'bottom',
        bottom: 30,
        selectedMode: false,
        textStyle: {
          fontFamily: variables.fontFamily,
          color: variables.black,
          fontSize: 14,
          fontWeight: 300,
          padding: 4,
        },
        itemGap: 20,
        icon: 'circle',
        itemWidth: 13,
        itemHeight: 13,
        // chart will fail if the names have the 'undefined' value
        data: chartData.data.map((m) => m.name || ''),
      },
      color: [variables.purple500, variables.blue700],
      backgroundColor: 'rgba(0,0,0,0)',
      textStyle: {
        fontFamily: variables.fontFamily,
        padding: [3, 5],
      },
      silent: true,
      radar: {
        indicator: chartData.indicators,
        animation: false,
        radius: ['22%', '80%'],
        axisName: {
          fontSize: 11,
          color: variables.grey500,
        },
        axisNameGap: 12,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            color: [variables.grey300],
          },
        },
        splitArea: {
          areaStyle: {
            color: [variables.grey100, variables.white],
          },
        },
      },
    },
    media: [
      {
        query: {
          maxWidth: 480,
        },
        option: {
          radar: {
            radius: ['0%', '63%'],
          },
        },
      },
    ],
  }
}
